// extracted by mini-css-extract-plugin
module.exports = {"link-button":"e2ff468f85--link-button--ujZuh"};